import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  DatastoreLoadshiftSiteStatsModule,
  DatastoreSiteStatsModule,
  DatastoreUsersSelfModule,
} from '@freelancer/datastore/collections';
import { FeatureFlagsModule } from '@freelancer/feature-flags';
import { LanguageSwitcherModule } from '@freelancer/language-switcher';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { FooterDeloitteComponent } from './footer-deloitte.component';
import { FooterFreelancerComponent } from './footer-freelancer.component';
import { FooterFreightlancerComponent } from './footer-freightlancer.component';
import { FooterComponent } from './footer.component';

@NgModule({
  imports: [
    UiModule,
    CommonModule,
    TrackingModule,
    DatastoreLoadshiftSiteStatsModule,
    DatastoreSiteStatsModule,
    DatastoreUsersSelfModule,
    LanguageSwitcherModule,
    FeatureFlagsModule,
  ],
  declarations: [
    FooterDeloitteComponent,
    FooterFreelancerComponent,
    FooterFreightlancerComponent,
    FooterComponent,
  ],
  exports: [
    FooterDeloitteComponent,
    FooterFreelancerComponent,
    FooterComponent,
  ],
})
export class FooterModule {}
